import React, { useContext } from "react";
import UserSideListView from "./UserSideListView";
import { Navigate } from "react-router-dom";
import PortalShell from "../Util/PortalShell";
import AuthContext from "../../store/auth-context";

const UserRootLayout = () => {
  const authCtx = useContext(AuthContext);
  if (!authCtx.user || authCtx.user.is_admin) {
    return <Navigate to={"/login"} />;
  }

  // Skip link, "Main" navigation, one main region, page title (ticket 11): see PortalShell
  return <PortalShell navigation={<UserSideListView />} />;
};

export default UserRootLayout;
